import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { DoorClosed, Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

const BG = "https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzaGlwcGluZyUyMHBvcnQlMjBjb250YWluZXJzJTIwZHJvbmV8ZW58MHx8fHwxNzg4MzkwOTYwfDA&ixlib=rb-4.1.0&q=85&w=1400";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      nav("/");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={BG} alt="contenedores" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/75" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-emerald-500 flex items-center justify-center">
              <DoorClosed className="h-6 w-6" />
            </div>
            <span className="font-display text-xl font-bold">PuertaCotiza</span>
          </div>
          <div>
            <h1 className="font-display text-4xl font-extrabold leading-tight">
              Cotización de proyectos de puertas
            </h1>
            <p className="mt-4 text-slate-300 max-w-md">
              Importación, costos y precios de venta en un solo lugar. Costos protegidos, ventas visibles.
            </p>
          </div>
          <p className="text-xs text-slate-400">Uso interno · Datos confidenciales</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-9 w-9 rounded-md bg-emerald-600 flex items-center justify-center text-white">
              <DoorClosed className="h-5 w-5" />
            </div>
            <span className="font-display text-lg font-bold">PuertaCotiza</span>
          </div>
          <h2 className="font-display text-2xl font-bold text-slate-900">Iniciar sesión</h2>
          <p className="text-sm text-slate-500 mt-1 mb-6">Ingresa tus credenciales para continuar.</p>

          <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wider mb-1">Email</label>
          <input
            data-testid="login-email"
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-4 px-3 py-2.5 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
            placeholder="tucorreo@empresa.com"
          />
          <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wider mb-1">Contraseña</label>
          <input
            data-testid="login-password"
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-6 px-3 py-2.5 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
            placeholder="••••••••"
          />
          <button
            data-testid="login-submit" type="submit" disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2.5 rounded-md transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Entrar
          </button>
          <p className="text-center text-xs text-slate-400 mt-5">
            El acceso es solo por invitación. Solicita tu cuenta a un administrador.
          </p>
        </form>
      </div>
    </div>
  );
}
